import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import Providers from './contexts/Providers';
import FlowWrapper from './modules/workflow/FlowWrapper';
import Home from './modules/Home/components/Home'; // Import the Home component
import Login from './modules/Login/components/Login';
import DefaultEditor from './modules/WebEditor';
// import WorkflowList from './WorkflowList';
import TemplatesContent from './modules/workflowTemplate/TemplatesContent';

import PortalBuilderTemplatesList from './modules/PortalBuilderTemplate/components/PortalBuilderTemplatesList';

import PortalBuilder from './modules/PortalBuilderTemplate/components/PortalBuilder';
import CreatePortalBuilder from './modules/PortalBuilderTemplate/components/CreateTemplate';
import MultiStepForm from './modules/TestWorkflow/MultiStepForm';

import LandingPage from './modules/TestWorkflow/LandingPage';
import PromptManager from './modules/PromptManagerTemplate/components/PromptManager';
import GardenWallApp from './modules/GardenWall/GardenWallApp';
import {
  COMPANY_API_CUSTOMER_ID,
  COMAPANY_ID,
  THEME_ID,
} from './constants/companyConfig';
import './index.css';
import './App.css';
// import AuthWrapper from './components/AuthWrapper';

// Error handling for ResizeObserver
const resizeObserverErrHandler = (e) => {
  if (e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation(); // Ignore the ResizeObserver error
  }
};

window.addEventListener('error', resizeObserverErrHandler);

function App() {
  // Need to fetch companyId from API

  const [client, setClient] = useState(COMAPANY_ID);
  const [themeId] = useState(THEME_ID);

  useEffect(() => {
    // Dynamically set the theme on the root element (or body)
    document.body.classList.add(`theme-${themeId}`);
    // if (theme) {
    //   document.body.classList.add(theme);
    // } else {
    //   document.body.classList.remove('prtc'); // Clear all themes if no theme is set
    // }

    return () => {
      document.body.classList.remove(`theme-${themeId}`);
    };
  }, [themeId]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Route for the Home page */}
      <Route path="/" element={<Home />} />

      {/* Route for the FlowWrapper workflow page */}
      <Route path="/workflow/:workflowId" element={<FlowWrapper />} />
      {/* <Route path="/portalBuilder" element={<DefaultEditor />}/> */}

      <Route path="/templates" element={<TemplatesContent />} />
      <Route
        path="/portal-builder-templates"
        element={<PortalBuilderTemplatesList />}
      />

      <Route
        path="/portalBuilder/:portalBuilderTemplateId"
        element={<PortalBuilder />}
      />
      <Route path="/portalBuilder/create" element={<CreatePortalBuilder />} />

      <Route path="/landing-page" element={<LandingPage />} />
      <Route path="/workflow/preview/:workflowId" element={<MultiStepForm />} />

      <Route path="/prompt-manager" element={<PromptManager />} />
      <Route path="/gardenwall/*" element={<GardenWallApp />} />
    </Routes>
  );
}

export default App;
